var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg9C5D174F649Db539A9C8F3Bc0A557Afb2153013372C36C7Dbddcb34012778B0F({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7998 0C5.73441 0 0.799805 4.9346 0.799805 11V15.5573C0.799805 16.6837 1.7865 17.6 2.9998 17.6H4.09981C4.39154 17.6 4.67133 17.4841 4.87762 17.2778C5.08391 17.0715 5.1998 16.7917 5.1998 16.5V10.8427C5.1998 10.551 5.08391 10.2712 4.87762 10.0649C4.67133 9.85859 4.39154 9.7427 4.09981 9.7427H3.101C3.7126 5.4857 7.37561 2.2 11.7998 2.2C16.224 2.2 19.887 5.4857 20.4986 9.7427H19.4998C19.2081 9.7427 18.9283 9.85859 18.722 10.0649C18.5157 10.2712 18.3998 10.551 18.3998 10.8427V17.6C18.3998 18.8133 17.4131 19.8 16.1998 19.8H13.9998V18.7H9.5998V22H16.1998C18.6264 22 20.5998 20.0266 20.5998 17.6C21.8131 17.6 22.7998 16.6837 22.7998 15.5573V11C22.7998 4.9346 17.8652 0 11.7998 0Z",
    fill: "#424143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9C5D174F649Db539A9C8F3Bc0A557Afb2153013372C36C7Dbddcb34012778B0F);
export default __webpack_public_path__ + "static/media/9c5d174f649db539a9c8f3bc0a557afb2153013372c36c7dbddcb34012778b0f.4a16124b7930028893024722f1c5e0ca.svg";
export { ForwardRef as ReactComponent };